import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {ConfigService} from '../../services/config/config.service';
import {UrlStore} from '../../../shared/url-store';

/**
 * Blocks direct navigation to a screen whose screen_config.is_enabled is
 * false (or missing) for this customer, mirroring the nav's visibility so
 * the two never disagree. Screen id is derived from the first URL segment,
 * which matches screen_config.screen_id for every top-level route
 * (dashboard, forecast, inventory, business-rules, business-rules-v2,
 * group-sales, status, configuration, help).
 */
@Injectable({
    providedIn: 'root'
})
export class ScreenEnabledGuard implements CanActivateChild {

    constructor(private configService: ConfigService, private router: Router) {
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const screenId = state.url.split('?')[0].split('/')[1];
        if (!screenId || this.configService.isScreenEnabled(screenId)) {
            return true;
        }
        // A GroupSales-role user has exactly one screen available to them -
        // send them there instead of a dead-end access-denied page.
        if (this.configService.isGroupSalesOnlyRole()) {
            this.router.navigate([UrlStore.ui.groupSales]);
        } else {
            this.router.navigate([UrlStore.ui.accessDeined]);
        }
        return false;
    }
}